var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.targetHref)?_c('div',{staticClass:"inline-flex items-center text-14 leading-20 text-white van-haptics-feedback",on:{"click":_vm.handleDownload}},[_c('svg-icon',{staticClass:"w-16 h-16 mr-6",attrs:{"pre-path":"itineraryUniversal","name":"ic-download"}}),_vm._v("\n  下载\n")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }